import api from '@/store/api'
var formal_examJs = {
  methods: {
    post_records_purchase (id, type) {
      const path = '/assessments/records/?purchase=no'

      return api.post(path, { id: id, type: type })
        .then((response) => {
          return response.data
        })
        .catch((err) => {
          return err.response.data
        })
    },
    post_assessments_records_start (item) {
      // 考試開始
      const self = this
      const path = '/assessments/records/?purchase=yes'
      self.$store.dispatch('isLoading', true)

      api.post(path, { id: item.id, type: item.type })
        .then((res) => {
          self.$store.dispatch('isLoading', false)
          self.$store.dispatch('getRemainPoints')
          // self.$router.push({ name: 'formal_exam', params: { select_id: item.id, practice_type: item.type }, query: { record_id: res.data.record_id } })
          self.$router.push({ name: this.returnRouter, params: { practice_type: item.type, exam_id: item.id }, query: { record_id: res.data.record_id } })
        // self.$router.push({ name: this.returnRouter, params: { params: { practice_type: item.type, exam_id: child2.id }, query: { record_id: res.data.record_id } })
        })
        .catch((err) => {
          self.$store.dispatch('isLoading', false)
          self.$swal.fire({
            focusConfirm: false,
            confirmButtonText: '確認',
            title: 'Notice',
            text: err.response.data.msg || '發生錯誤',
            customClass: {
              title: 'text-white',
              container: '',
              popup: 'p-0',
              header: 'swal-header-notice justify-center items-center',
              closeButton: '',
              htmlContainer: 'font-semibold my-4 text-2xl',
              actions: 'mb-4 mt-2',
              confirmButton: 'btn-submit',
              cancelButton: 'bg-red-main-ai'
            }
          })
        })
    },
    // post_assessments_records (exam_id, questionId, part, text, file) {
    //   let path = `/assessments/records/${exam_id}`

    //   let formData = new FormData()
    //   formData.append('file', file)
    //   formData.append('id', questionId)
    //   formData.append('part', part)
    //   formData.append('text', text || '')

    //   return api.post(path, formData, {
    //     headers: {
    //       "Content-Type": "multipart/form-data",
    //       'showLoading': false
    //     }
    //   })
    //   .then((response) => {
    //     console.log(response.data)
    //     return response.data
    //   })
    //   .catch((err) => {
    //     console.log('err: ' + err)
    //   })
    // },
    async post_assessments_records (exam_id, questionId, part, text, file) {
      const path = `/assessments/records/${exam_id}`

      const formData = new FormData()
      formData.append('file', file)
      formData.append('id', questionId)
      formData.append('part', part)
      formData.append('text', text || '')

      const config = {
        headers: { 'Content-Type': 'multipart/form-data', showLoading: false }
        // onUploadProgress: (progressEvent) => {
        //   const percent = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        //   console.log(`Upload progress: ${percent}%`);
        // }
      }

      // 定義一個函數執行上傳
      const tryPost = async () => {
        try {
          const response = await api.post(path, formData, config)
          console.log('Upload success:', response.data)
          return response.data
        } catch (err) {
          console.error('Upload failed:', err)
          throw err
        }
      }

      // 嘗試上傳一次，失敗再重試一次
      try {
        return await tryPost()
      } catch (firstErr) {
        console.warn('Retrying upload...')
        try {
          return await tryPost()
        } catch (secondErr) {
          console.error('Upload failed twice:', secondErr)
          return Promise.reject(secondErr)
        }
      }
    },

    post_assessments_records_finish (exam_id) {
      let attempt = 0
      const maxRetries = 10
      const retryInterval = 5000
      const path = `/assessments/records/${exam_id}/finish`
      this.$store.dispatch('isLoading', true)

      const options = { headers: { showLoading: false } }
      const makeRequest = () => {
        api.post(path, options)
          .then(() => {
            this.$store.dispatch('isLoading', false)

            this.$router.push({ name: 'TOEIC_report', params: { practice_type: 'speaking', record_id: exam_id } })
          })
          .catch(() => {
            attempt++
            if (attempt < maxRetries) {
              setTimeout(makeRequest, retryInterval)
            }
          })
      }

      makeRequest()
    },

    get_assessments_records (exam_id) {
      // let self = this

      const path = `/api/toeic/exams/${exam_id}/records`

      return api.get(path)
        .then((res) => {
          return res
        })
        .catch(() => {
        })
    }
  }
}

export default formal_examJs
